import { Box, Stack, TextField } from "@mui/material";
import { Dispatch, SetStateAction, memo, useState } from "react";
import { useTranslation } from "react-i18next";

import FiltersActions from "../../../../components/FiltersActions/FiltersActions";
import useFilter from "../../../../hooks/useFilter";
import { DatePickerUncontrolled, DateRangeSelect } from "@4uhub/lib4uhub";

interface IMacroFilterProps {
  onFilter: Dispatch<SetStateAction<IFilterTasyIpmParams>>;
  filterParams: IFilterTasyIpmParams;
}

export interface IFilterTasyIpmParams {
  Status: string;
  TasyEncounterIntegrationId: string;
  TasyIndividualIntegrationId: string;
  IpmEncounterIntegrationId: string;
  IpmIndividualIntegrationId: string;
  CreatedInitial: Date;
  CreatedEnd: Date;
  refresh?: boolean;
}

const translationPath = "page.4uBus.logs.logTasyImp.";

const MacroFilterIpmTasy: React.FC<IMacroFilterProps> = ({
  onFilter,
  filterParams,
}) => {
  const {
    // disableFilterBtn,
    filter,
    showCleanBtn,
    initialState,
    setFilter,
    cleanFilter,
  } = useFilter(filterParams);

  const { t } = useTranslation();

  const [enableFields, setEnableFields] = useState<boolean>(true);
  const [resetDateRange, setResetDateRange] = useState<boolean>(false);

  const handleStartDate = (date: Date | null) => {
    setFilter({ CreatedInitial: date ? date : undefined });
  };
  const handleEndDate = (date: Date | null) => {
    setFilter({ CreatedEnd: date ? date : undefined });
  };

  const filterHandler = () => {
    onFilter(filter);
  };

  const cleanHandler = () => {
    onFilter(initialState.current);
    cleanFilter();
    setResetDateRange((prev) => !prev);
  };

  return (
    <Stack flexDirection={"row"} gap={2}>
      <DateRangeSelect
        setEndDate={handleEndDate}
        setStartDate={handleStartDate}
        setEnableFields={setEnableFields}
        resetToToday={resetDateRange}
      />
      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.CreatedInitial}
          onChange={(e) => setFilter({ CreatedInitial: e ? e : undefined })}
          label={`${t(translationPath + "start_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>
      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.CreatedEnd}
          onChange={(e) => setFilter({ CreatedInitial: e ? e : undefined })}
          label={`${t(translationPath + "end_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>
      <TextField
        value={filter?.Status}
        size="small"
        label={t(translationPath + "status")}
        fullWidth
        onChange={(e) =>
          setFilter({
            Status: e.target.value,
          })
        }
      />

      <TextField
        value={filter?.TasyEncounterIntegrationId}
        size="small"
        type="number"
        label={t(translationPath + "TasyEncounterIntegrationId")}
        fullWidth
        onChange={(e) =>
          setFilter({
            TasyEncounterIntegrationId: e.target.value,
          })
        }
      />

      <TextField
        value={filter?.TasyIndividualIntegrationId}
        size="small"
        type="number"
        label={t(translationPath + "TasyIndividualIntegrationId")}
        fullWidth
        onChange={(e) =>
          setFilter({
            TasyIndividualIntegrationId: e.target.value,
          })
        }
      />

      <TextField
        value={filter?.IpmEncounterIntegrationId}
        size="small"
        type="number"
        label={t(translationPath + "IpmEncounterIntegrationId")}
        fullWidth
        onChange={(e) =>
          setFilter({
            IpmEncounterIntegrationId: e.target.value,
          })
        }
      />

      <TextField
        value={filter?.IpmIndividualIntegrationId}
        size="small"
        type="number"
        label={t(translationPath + "IpmIndividualIntegrationId")}
        fullWidth
        onChange={(e) =>
          setFilter({
            IpmIndividualIntegrationId: e.target.value,
          })
        }
      />

      <FiltersActions
        onFilter={filterHandler}
        onClean={cleanHandler}
        // disableFilterBtn={disableFilterBtn}
        showCleanBtn={showCleanBtn}
      />
    </Stack>
  );
};
export default memo(MacroFilterIpmTasy);
